@if (isLoading == false) {
  @if (outcome.Outcome == 1) {
    @if (isSteppedProductAvailable) {
      <div>
        <p class="mb-2 mb-sm-4 lead-sm">We are able to offer you the following:</p>
      </div>
    }
    <div class="row">
      <!-- Product 0 -->
      @if (isSteppedProductAvailable) {
        <div class="col-12 col-lg-6">
          <!-- ///// Standard Product Summary ///// -->
          <div class="card card-options mb-4 mb-lg-0  h-lg-100">
            <div class="card-header d-flex pb-0">
              <h5 class="font-source mb-0 align-self-center">Standard rate product</h5>
            </div>
            <div class="card-body">
              <div class="row mt-2 mt-sm-0">
                <div class="col-12 mb-0 mb-sm-1 d-none d-lg-block h-adjust">
                  &nbsp;
                </div>
                <div class="col-8 col-sm-4 col-lg-6 mb-0 mb-md-2">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly instalment: </span>
                  </h6>
                </div>
                <div class="col-4 col-sm-8 col-lg-6 mb-0 mb-md-2">
                  <h6 class="font-source">
                    &pound;{{ this.outcome.Products[0]?.InitialRepayment | number : '1.2-2' }}
                  </h6>
                </div>
                <div class="col-8 col-sm-4 col-lg-6 mb-2 mb-md-0">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                  </h6>
                </div>
                <div class="col-4 col-sm-8 col-lg-6 mb-2 mb-md-0">
                  <h6 class="font-source">
                    {{ this.outcome.Products[0].InitialRate | number : '1.2-2' }}%
                  </h6>
                </div>
              </div>
            </div>
            <!-- ///// Standard Product CTA - SELECT & VIEW DETAILS ///// -->
            <div class="card-footer pb-3 pt-0 text-muted">
              <div class="row">
                <div class="col-6 col-md-4">
                  <button class="c-button c-button--neutral mb-0" [ngClass]="{ 'active': isReducedRateProduct === false }" (click)="selectRateType(this.outcome.Products[0]?.PlanCode, false)">
                    Select
                    <span class="svg">
                      <svg aria-hidden="true" class="c-radio-button__faux-indicator icon-tick" focusable="false" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" fill="#f9b114"></path>
                      </svg>
                    </span>
                  </button>
                </div>
                <div class="col-6 col-md-4">
                  <button class="c-button c-button--inverse mb-0" (click)="open(content)">
                    View details
                  </button>
                </div>
              </div>
            </div>
            <!-- ///// Standard Product CTA END ///// -->
          </div>
          <!-- \\\\\\ Standard Product Summary END \\\\\\ -->
        </div>
      }
      <!-- PRODUCT 1 -->
      @if (isSteppedProductAvailable) {
        <div class="col-12 col-lg-6">
          <!-- ///// Discounted Product Summary ///// -->
          <div class="card card-options  mb-4 mb-sm-0">
            <div class="card-header d-flex pb-0">
              <h5 class="font-source mb-0 align-self-center">
              Discounted rate product</h5>
            </div>
            <div class="card-body">
              <div class="row mt-2 mt-sm-0">
                <div class="col-6  order-sm-1 col-sm-4 col-lg-6 d-none d-sm-block">
                  &nbsp;
                </div>
                <div class="col-12 order-1  order-sm-2 col-sm-4 col-md-3 col-lg-3 small mb-2">
                  First
                  <br class="d-none d-sm-block" /> 6 months
                </div>
                <div class="col-12 order-7 order-sm-3 col-sm-4 col-md-5 col-lg-3 small mb-2">
                  Second
                  <br class="d-none d-sm-block" /> 6 months
                </div>
                <div class="col-8 order-3 order-sm-4 col-sm-4 col-lg-6 mb-md-2">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly instalment: </span>
                  </h6>
                </div>
                <div class="col-4 order-4 order-sm-5 col-sm-4 col-md-3 col-lg-3  mb-md-2">
                  <h6 class="font-source">
                    &pound;{{ this.outcome.Products[1]?.InitialRepayment }}
                  </h6>
                </div>
                <div class="col-8 order-8 d-flex d-sm-none">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly instalment: </span>
                  </h6>
                </div>
                <div class="col-4 order-9 order-sm-6 col-md-5 col-sm-4 col-lg-3">
                  <h6 class="font-source">
                    &pound;{{ this.outcome.Products[1]?.RevisedRepayment | number : '1.2-2' }}
                  </h6>
                </div>
                <div class="col-8 order-5 order-sm-7 col-sm-4 col-lg-6  mb-2 mb-sm-0">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                  </h6>
                </div>
                <div class="col-4 order-6 order-sm-8 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
                  <h6 class="font-source">
                    {{ this.outcome.Products[1]?.InitialRate | number : '1.2-2' }}%
                  </h6>
                </div>
                <div class="col-8 order-10 d-flex d-sm-none mb-2 mb-sm-0">
                  <h6 class="font-source">
                    <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                  </h6>
                </div>
                <div class="col-4 order-11 order-sm-9 col-sm-4 col-md-5 col-lg-3">
                  <h6 class="font-source">
                    {{ this.outcome.Products[1]?.RevisedRate | number : '1.2-2' }}%
                  </h6>
                </div>
              </div>
            </div>
            <!-- ///// Discounted Product CTA - SELECT & VIEW DETAILS ///// -->
            <div class="card-footer pb-3 pt-0 text-muted">
              <div class="row">
                <div class="col-6 col-md-4">
                  <button class="c-button c-button--neutral mb-0" [ngClass]="{ 'active': isReducedRateProduct === true}" (click)="selectRateType(this.outcome.Products[1]?.PlanCode, true)">
                    Select
                    <span class="svg">
                      <svg aria-hidden="true" class="c-radio-button__faux-indicator icon-tick" focusable="false" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" fill="#f9b114"></path>
                      </svg>
                    </span>
                  </button>
                </div>
                <div class="col-6 col-md-4">
                  <button class="c-button c-button--inverse mb-0" (click)="open(content1)">
                    View details
                  </button>
                </div>
              </div>
            </div>
            <!-- ///// Discounted Product CTA END ///// -->
          </div>
          <!-- \\\\\\ Discounted Product Summary END \\\\\\ -->
        </div>
      }
      @if (isProductSelected && isSteppedProductAvailable) {
        <div class="col-12">
          <div class="d-flex invalid-feedback pt-3">Please select a product to proceed.</div>
        </div>
      }
      <!-- Stage Select -->
      @if (isSteppedProductAvailable) {
        <div class="col-12 col-md-10 col-lg-7">
          <div class="row mt-sm-5">
            <div class="col-sm order-sm-last">
              <button class="c-button c-button--neutral" type="button" (click)="handleEditDip($event)">
                <svg class="c-button__icon c-button__icon--left icon-arrow-left" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 8.06 14.71">
                  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M7.71.35l-7 7 7 7" />
                </svg>
                Edit your pre-approval
              </button>
            </div>
            <div class="col-sm order-sm-last">
              <button class="c-button c-button--accent" type="button" (click)="requote()">
                Proceed
                <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 8.06 14.71">
                  <path fill="none" stroke="#3F2B56" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      }
      <!-- Stage Select END -->
    </div>
    <!-- Dip Outcome - HIDDEN FOR DEV - REMOVE FOR PRODUCTION -->
    @if (!isSteppedProductAvailable) {
      <div class="row">
        <!-- Dip offer-->
        <div class="col-12 col-md-6">
          <div class="c-block">
            <!-- <h5 class="mb-1">We’re delighted to pre-approve a loan of :</h5>
            <h3 class="mb-3 font-source">
              <strong>£{{formattedLoanAmount}}</strong>
            </h3> -->
            <p>It’s important to remember that this is a pre-approval. Our final decision to lend is only made when you’ve submitted a full application and we’ve completed some final checks.</p>
            <h5 class="mb-0 font-source">
              @if (!isOfferEligible) {
                <div>
                  <strong>Your offer consists of:</strong>
                </div>
              }
              @if (isOfferEligible) {
                <div>
                  <strong>You're eligible for our standard rate product:</strong>
                </div>
              }
            </h5>
            <!-- ///// Offer Summary Standard ///// -->
            @if (!isSteppedProduct) {
              <div class="card card-options  mb-4 mb-sm-0">
                <div class="card-body px-0">
                  <div class="row mt-2 mt-sm-0">
                    <div class="col-8 col-sm-4 col-lg-6 mb-md-2">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly instalment: </span>
                      </h6>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 col-lg-3  mb-md-2">
                      <h6 class="font-source">
                        &pound;{{this.outcome.Products[0]?.InitialRepayment | number : '1.2-2'}}
                      </h6>
                    </div>
                    <div class="col-8 col-sm-4 col-lg-6  mb-2 mb-sm-0">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                      </h6>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
                      <h6 class="font-source">
                        {{ formattedInitialRate | number : '1.2-2' }}%
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- ///// Offer Summary Standard END ///// -->
            <!-- ///// Offer Summary Stepped ///// -->
            @if (isSteppedProduct) {
              <div class="card card-options  mb-4 mb-sm-0">
                <div class="card-body px-0">
                  <div class="row mt-2 mt-sm-0">
                    <div class="col-6  order-sm-1 col-sm-4 col-lg-6 d-none d-sm-block">
                      &nbsp;
                    </div>
                    <div class="col-12 order-1  order-sm-2 col-sm-4 col-md-3 col-lg-3 small mb-2">
                      First
                      <br class="d-none d-sm-block" /> 6 months
                    </div>
                    <div class="col-12 order-7 order-sm-3 col-sm-4 col-md-5 col-lg-3 small mb-2">
                      Second
                      <br class="d-none d-sm-block" /> 6 months
                    </div>
                    <div class="col-8 order-3 order-sm-4 col-sm-4 col-lg-6 mb-md-2">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly instalment: </span>
                      </h6>
                    </div>
                    <div class="col-4 order-4 order-sm-5 col-sm-4 col-md-3 col-lg-3  mb-md-2">
                      <h6 class="font-source">
                        &pound;{{this.outcome.Products[0]?.InitialRepayment | number : '1.2-2'}}
                      </h6>
                    </div>
                    <div class="col-8 order-8 d-flex d-sm-none">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly instalment: </span>
                      </h6>
                    </div>
                    <div class="col-4 order-9 order-sm-6 col-md-5 col-sm-4 col-lg-3">
                      <h6 class="font-source">
                        &pound;{{ this.outcome.Products[0]?.RevisedRepayment | number : '1.2-2' }}
                      </h6>
                    </div>
                    <div class="col-8 order-5 order-sm-7 col-sm-4 col-lg-6  mb-2 mb-sm-0">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                      </h6>
                    </div>
                    <div class="col-4 order-6 order-sm-8 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
                      <h6 class="font-source">
                        {{ formattedInitialRate | number : '1.2-2' }}%
                      </h6>
                    </div>
                    <div class="col-8 order-10 d-flex d-sm-none mb-2 mb-sm-0">
                      <h6 class="font-source">
                        <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                      </h6>
                    </div>
                    <div class="col-4 order-11 order-sm-9 col-sm-4 col-md-5 col-lg-3">
                      <h6 class="font-source">
                        {{ this.outcome.Products[0]?.RevisedRate | number : '1.2-2' }}%
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- ///// Offer Summary Stepped End ///// -->
            <!-- <table>
            <tr>
              <td width="200">
                <h6 class="font-source">
                  <span class="text-dark font-weight-light">Monthly instalment: </span>
                </h6>
              </td>
              <td align="left">
                <h6 class="font-source">
                  <strong>£{{formattedMonthlyInstallment}}</strong>
                </h6>
              </td>
              <td width="200">
                <h6 class="font-source">
                  <span class="text-dark font-weight-light">Monthly instalment: </span>
                </h6>
              </td>
              <td align="left">
                <h6 class="font-source">
                  <strong>£{{formattedSteppedonthlyInstallment}}</strong>
                </h6>
              </td>
            </tr>
            <tr>
              <td>
                <h6 class="font-source">
                  <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                </h6>
              </td>
              <td align="right">
                <h6 class="font-source">
                  <strong>{{formattedInitialRate}}%</strong>
                </h6>
              </td>
              <td>
                <h6 class="font-source">
                  <span class="text-dark font-weight-light"> Monthly interest rate: </span>
                </h6>
              </td>
              <td align="right">
                <h6 class="font-source">
                  <strong>{{formattedSteppedInitialRate}}%</strong>
                </h6>
              </td>
            </tr>
          </table> -->
          <p class="mb-0">
            <button class="c-button c-button--inverse" type="button" (click)="handleGetDIPCertificate($event)">
              {{actionText}}
              <svg class="c-button__icon c-button__icon--right icon-document" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 21 25">
                <path fill="none" stroke="#fff" stroke-miterlimit="10" d="M.5 23.37V.5h18.75l1.25 1.26v18.67l-4.04 4.07H1.49L.5 23.37z" />
                <path fill="none" stroke="#fff" stroke-miterlimit="10" d="M14.33 23.4v-5.65h5.03M4.22 4.74h12.56M4.22 8.63h12.56M4.22 12.65h12.56"
                  />
                </svg>
              </button>
            </p>
          </div>
        </div>
        @if (!isSteppedProductAvailable) {
          <div class="col-12 col-md-6">
            <h4>Good luck on auction day</h4>
            <p>Now you know how much you might be able to borrow, you can start bidding with more confidence to secure the property you're after.</p>
            <h5>Have you already purchased your property?</h5>
            <p>Great! All we need to complete a full application are some additional loan details and your chosen solicitor.</p>
            <p>It's quick and easy, but if you'd like to speak to us, call our team on
              <strong><a href="tel:+01614513157">0161 768 5337</a>.</strong>
            </p>
            <p>
              <a href="https://togethermoney.com/auction-finance/" target="_blank" title="Visit our website">Visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.
            </p>
          </div>
        }
        <!-- Stage Select -->
        <div class="col-12 col-md-10 col-lg-7">
          <div class="row mt-sm-3">
            <div class="col-sm order-sm-last">
              <button class="c-button c-button--neutral" type="button" (click)="handleEditDip($event)">
                <svg class="c-button__icon c-button__icon--left icon-arrow-left" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 8.06 14.71">
                  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M7.71.35l-7 7 7 7" />
                </svg>
                Edit your pre-approval
              </button>
            </div>
            @if (!isSteppedProductAvailable) {
              <div class="col-sm order-sm-last">
                <button class="c-button c-button--accent" type="button" (click)="handleForward()">
                  {{forwardText}}
                  <!-- Proceed -->
                  <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 8.06 14.71">
                    <path fill="none" stroke="#3F2B56" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" />
                  </svg>
                </button>
              </div>
            }
          </div>
        </div>
        <!-- Stage Select END -->
      </div>
    }
  }
  <!-- Alternative copy when Product 0 -->
  @if (outcome.Outcome == 2) {
    <div class="c-wysiwyg">
      <h5>Our experienced team are reviewing the information you’ve provided.</h5>
      <p>We’ll be in touch to let you know if we’ve been able to pre-approve your loan, normally within one working day. In the meantime, if you’d like to speak to us call our team on
        <strong><a href="tel:+01614513157">0161 768 5337</a></strong>.</p>
        <p>
          <a href="http://www.togethermoney.com" target="_blank" title="Visit our website">Visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.</p>
        </div>
      }
      @if (outcome.Outcome == 3) {
        <div class="c-wysiwyg">
          <h5>Based on the figures you’ve entered, we wouldn’t be able to lend you what you need.</h5>
          <p>This is because we can only lend up to 75% of the property’s value.
            You’re welcome to go back and try again with different figures. Or if you’d like to speak to a member of our team instead, give us a call on <strong>0161 933 7099</strong>.
          </p>
          <p>
            <a href="http://www.togethermoney.com" target="_blank" title="Visit our website">Click here</a> for more information about how auction finance works, and find handy hints and tips for auction day itself.</p>
          </div>
        }
      }

      <!-- ///// Standard Product MODAL ///// -->
      <ng-template #content let-c="close" let-d="dismiss">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">Standard rate</h5>
          <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="alert alert-light bg-purple-light">
            <h4 class="mb-3">
              Interest payments
              <br class="d-block d-sm-none"> (over 12 months)
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'This is the amount you will need to pay each month, to cover the interest that falls due.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Interest Rate <br class="d-block d-sm-none" /> Per Month </p>
                <h5 class="mb-0">
                  {{ this.outcome.Products[0].InitialRate | number : '1.2-2' }}%
                </h5>
              </div>
              <div class="col-6 col-sm-8">
                <p class="text-dark mb-1">Monthly Interest <br class="d-block d-sm-none" /> Payment</p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[0]?.InitialRepayment | number : '1.2-2' }}
                </h5>
              </div>
            </div>

          </div>
          <div class="alert alert-light bg-purple-light">
            <h4 class="mb-3">
              Loan details
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'The loan details are outlined here.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Total Amount to be Borrowed </p>

                <h5 class="mb-3 mb-sm-0">
                  &pound;{{ this.outcome.Products[0].TotalAmountToBeRepaid | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Loan Amount you will receive </p>
                <h5 class="mb-0">
                  &pound;{{formattedLoanAmount}}
                </h5>
              </div>
            </div>
          </div>
          <div class="alert alert-light bg-purple-light mb-0">
            <h4 class="mb-3">
              Your Fees
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'The fees associated with the loan are outlined here.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-12">
                <h5 class="mb-2">Fees included in your loan </h5>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Acceptance Fee </p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[0].AcceptanceFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Title Insurance</p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[0].TitleInsuranceFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-12 mt-3">
                <h5 class="mb-2">Fees payable at the end of your loan</h5>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Exit Fee </p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[0].ExitFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Redemption Admin Fee </p>
                <h5 class="mb-0">&pound;{{ this.outcome.Products[0].AdminFee | number : '1.2-2' }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Footer CTA -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-purple" (click)="c('Close click')">Close</button>
        </div>
      </ng-template>
      <together-auction-dip-loading [is_loading]="isLoading"></together-auction-dip-loading>

      <!-- ///// Discounted Product MODAL ///// -->
      <ng-template #content1 let-c="close" let-d="dismiss">
        <!-- Modal Header -->

        <div class="modal-header">
          <h5 class="modal-title">Discounted rate</h5>
          <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="alert alert-light bg-purple-light">
            <h4 class="mb-3">
              Interest payments
              <br class="d-block d-sm-none">(12 months)
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'This is the amount you will need to pay each month, to cover the interest that falls due.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-6 col-sm-3">
                <p class="text-dark mb-1">Interest rate
                <br />- first 6 months </p>

                <h5 class="mb-2 mb-sm-0">
                  {{ this.outcome.Products[1]?.InitialRate | number : '1.2-2' }}%
                </h5>
              </div>
              <div class="col-6 col-sm-3">
                <p class="text-dark mb-1">Interest payment
                <br />- first 6 months </p>
                <h5 class="mb-2 mb-sm-0">
                  &pound;{{ this.outcome.Products[1]?.InitialRepayment | number : '1.2-2' }}
                </h5>

              </div>
              <div class="col-6 col-sm-3">
                <p class="text-dark mb-1">Interest rate
                <br />- second 6 months </p>
                <h5 class="mb-2 mb-sm-0">
                  {{ this.outcome.Products[1]?.RevisedRate | number : '1.2-2' }}%
                </h5>
              </div>
              <div class="col-6 col-sm-3">
                <p class="text-dark mb-1">Interest payment
                <br />- second 6 months </p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[1]?.RevisedRepayment | number : '1.2-2' }}
                </h5>
              </div>
            </div>
          </div>
          <div class="alert alert-light bg-purple-light">
            <h4 class="mb-3">
              Loan details
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'The loan details are outlined here.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Total Amount to be Borrowed </p>
                <h5 class="mb-2 mb-sm-0">
                  &pound;{{ this.outcome.Products[1]?.TotalAmountToBeRepaid | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Loan Amount you will receive </p>
                <h5 class="mb-0">
                  &pound;{{ formattedLoanAmount }}
                </h5>
              </div>
            </div>
          </div>
          <div class="alert alert-light bg-purple-light mb-0">
            <h4 class="mb-3">
              Your Fees
              <together-auction-dip-tooltip [class]="'tooltip-modal'" [title]="'The fees associated with the loan are outlined here.'" [placement]="'bottom'"></together-auction-dip-tooltip>
            </h4>
            <div class="row">
              <div class="col-12">
                <h6 class="mb-2">Fees included in your loan</h6>
              </div>
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Acceptance fee </p>
                <h5 class="mb-2 mb-sm-0">
                  &pound;{{ this.outcome.Products[1]?.AcceptanceFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-12 col-sm-4">
                <p class="text-dark mb-1">Title Insurance</p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[1]?.TitleInsuranceFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-12 mt-3">
                <h6 class="mb-2">Fees payable at the end of your loan</h6>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Exit Fee </p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[1]?.ExitFee | number : '1.2-2' }}
                </h5>
              </div>
              <div class="col-6 col-sm-4">
                <p class="text-dark mb-1">Redemption Admin Fee </p>
                <h5 class="mb-0">
                  &pound;{{ this.outcome.Products[1]?.AdminFee | number : '1.2-2' }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-purple" (click)="c('Close click')">Close</button>
        </div>
      </ng-template>
      <together-auction-dip-loading [is_loading]="isLoading"></together-auction-dip-loading>

      <!-- <pre><code>{{this.outcome.Products | json}}</code></pre> -->
